function formatNow(timezone) {
    try {
        return new Intl.DateTimeFormat('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: timezone,
        }).format(new Date());
    } catch (e) {
        return '—';
    }
}

function updateLiveClocks(elements) {
    elements.forEach((el) => {
        const tz = el.getAttribute('data-timezone');
        if (!tz) return;
        el.textContent = formatNow(tz);
    });
}

export function initContactTimezoneClock() {
    const elements = document.querySelectorAll('.js-live-clock[data-timezone]');
    if (elements.length === 0) return;

    updateLiveClocks(elements);
    setInterval(() => {
        updateLiveClocks(document.querySelectorAll('.js-live-clock[data-timezone]'));
    }, 60000);
}
